/* ============================================================
   Casavelli — Theme JavaScript
   ============================================================ */

(function () {
  'use strict';

  /* ── Scroll reveal ──────────────────────────────────────── */
  function initReveal() {
    const els = document.querySelectorAll('.reveal');
    if (!els.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    els.forEach(el => observer.observe(el));
  }

  /* ── Header scroll state ────────────────────────────────── */
  function initHeader() {
    const header = document.querySelector('.site-header');
    if (!header) return;

    const toggle = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 60);
    };

    window.addEventListener('scroll', toggle, { passive: true });
    toggle();
  }

  /* ── Mobile nav drawer ──────────────────────────────────── */
  function initMobileNav() {
    const toggle = document.querySelector('.nav-mobile-toggle');
    const drawer = document.querySelector('.nav-drawer');
    const close  = document.querySelector('.nav-drawer__close');
    const overlay = document.querySelector('.overlay');

    if (!toggle || !drawer) return;

    const open  = () => { drawer.classList.add('is-open'); overlay && overlay.classList.add('is-visible'); document.body.style.overflow = 'hidden'; };
    const shut  = () => { drawer.classList.remove('is-open'); overlay && overlay.classList.remove('is-visible'); document.body.style.overflow = ''; };

    toggle.addEventListener('click', open);
    close && close.addEventListener('click', shut);
    overlay && overlay.addEventListener('click', shut);
  }

  /* ── Cart drawer ────────────────────────────────────────── */
  function initCartDrawer() {
    const triggers = document.querySelectorAll('[data-cart-trigger]');
    const drawer   = document.querySelector('.cart-drawer');
    const close    = document.querySelector('[data-cart-close]');
    const overlay  = document.querySelector('.overlay');

    if (!drawer) return;

    const open = () => { drawer.classList.add('is-open'); overlay && overlay.classList.add('is-visible'); document.body.style.overflow = 'hidden'; };
    const shut = () => { drawer.classList.remove('is-open'); overlay && overlay.classList.remove('is-visible'); document.body.style.overflow = ''; };

    triggers.forEach(t => t.addEventListener('click', e => { e.preventDefault(); open(); }));
    close && close.addEventListener('click', shut);
  }

  /* ── Size selector ──────────────────────────────────────── */
  function initSizeSelector() {
    const options = document.querySelectorAll('.size-option:not(.is-unavailable)');
    options.forEach(opt => {
      opt.addEventListener('click', () => {
        options.forEach(o => o.classList.remove('is-selected'));
        opt.classList.add('is-selected');
        const variantId = opt.dataset.variantId;
        const addBtn = document.querySelector('.add-to-cart');
        if (addBtn && variantId) addBtn.dataset.variantId = variantId;
      });
    });
  }

  /* ── Add to cart ────────────────────────────────────────── */
  function initAddToCart() {
    const btn = document.querySelector('.add-to-cart');
    if (!btn) return;

    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) {
        const firstSize = document.querySelector('.size-option:not(.is-unavailable)');
        if (firstSize) { firstSize.click(); return; }
        return;
      }

      btn.textContent = 'Adding…';
      btn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
        if (res.ok) {
          btn.textContent = 'Added';
          setTimeout(() => {
            btn.textContent = 'Add to Cart';
            btn.disabled = false;
            updateCartCount();
            openCartDrawer();
          }, 800);
        }
      } catch {
        btn.textContent = 'Add to Cart';
        btn.disabled = false;
      }
    });
  }

  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const badge = document.querySelector('.cart-count');
      if (badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
      }
    } catch {}
  }

  function openCartDrawer() {
    const drawer = document.querySelector('.cart-drawer');
    const overlay = document.querySelector('.overlay');
    if (drawer) { drawer.classList.add('is-open'); overlay && overlay.classList.add('is-visible'); }
  }

  /* ── Gallery thumbnails ─────────────────────────────────── */
  function initGallery() {
    const thumbs = document.querySelectorAll('.gallery-thumb');
    const main   = document.querySelector('.gallery-main img');
    if (!thumbs.length || !main) return;

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const src  = thumb.dataset.src;
        const srcset = thumb.dataset.srcset;
        if (src) main.src = src;
        if (srcset) main.srcset = srcset;
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  /* ── Filter pills (collection) ──────────────────────────── */
  function initFilters() {
    const pills = document.querySelectorAll('.filter-pill');
    pills.forEach(pill => {
      pill.addEventListener('click', () => {
        pills.forEach(p => p.classList.remove('is-active'));
        pill.classList.add('is-active');
      });
    });
  }

  /* ── Boot ───────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', () => {
    initReveal();
    initHeader();
    initMobileNav();
    initCartDrawer();
    initSizeSelector();
    initAddToCart();
    initGallery();
    initFilters();
    updateCartCount();
  });
})();
